<template>
  <v-row no-gutters class="tool-bar-style">
    <v-col cols="12">
      <h4>{{ windowTitle }}</h4>
    </v-col>
    <v-col cols="12" class="mb-3">
      <label>
        <h4>Name</h4>
      </label>
      <v-text-field hide-details="" v-model="data.text" placeholder="Name"></v-text-field
    ></v-col>
    <v-col cols="12">
      <label>
        <h4>Font size</h4>
      </label>
      <v-select
        placeholder="Font size"
        hide-details=""
        aria-orientation="bottom"
        :items="itemsFontsize"
        item-text="name"
        v-model="data.fontSize"
        item-value="id"
      >
      </v-select>
    </v-col>
    <v-col cols="12">
      <v-row>
        <v-col cols="10">
          <label>
            <h4>Font family</h4>
          </label>
          <div>
            <div style="width: 90%; float: left;">
              <v-combobox
                placeholder="Font family"
                hide-details=""
                aria-orientation="bottom"
                class="mr-3"
                item-text="name"
                item-value="name"
                :items="fonts"
                @change="changeFont"
              >
                <template v-slot:item="{ index, item }">
                  <v-chip :color="`#4181cb`" text-color="#eee" label small>
                    {{ item.name }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-list-item-action v-if="!item.isPublic" @click.stop="removeFont(item, index)">
                    <i class="fas fa-trash-alt" @click.stop="removeFont(item, index)"></i>
                  </v-list-item-action>
                </template>
              </v-combobox>
            </div>
            <div>
              <label title="Add font" class="myFile2 mb-3 d-inline-block pointer">
                <i class="fas fa-plus-circle fz-20 mt-3 pointer"></i>
                <input
                  ref="fileUploader"
                  style="width: 30px"
                  @change="uploadFont"
                  type="file"
                  class="pointer"
                  accept=".ttf,.otf"
                />
              </label>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="mb-3">
      <label>
        <h4>Label (display on storefront)</h4>
      </label>
      <v-text-field hide-details="" v-model="data.bodyHtml" placeholder="Label"></v-text-field
    ></v-col>
    <v-col cols="12" class="mb-3">
      <label>
        <h4>Placeholder (optional)</h4>
      </label>
      <v-text-field hide-details="" v-model="data.placeholder" placeholder="Placeholder"></v-text-field
    ></v-col>
    <v-col cols="12" class="mb-3">
      <label>
        <h4>Max length</h4>
      </label>
      <v-text-field hide-details="" v-model="data.maxLength" placeholder="Max length"></v-text-field
    ></v-col>
    <v-col cols="12" class="mb-3"
      ><h4>Required?</h4>
      <v-radio-group class="mt-0" v-model="data.required" row>
        <v-radio label="No" :value="false"></v-radio>
        <v-radio label="Yes" :value="true"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" class="mb-3">
      <label>
        <h4>Text style</h4>
      </label>
      <div v-if="isTextColor" class="position:relative">
        <div class="sketch-color">
          <sketch-picker
            v-click-outside="onClickOutside"
            v-if="isShowSelectionColor"
            @input="updateValue"
            v-model="colors"
          />
        </div>
      </div>
      <v-btn-toggle @change="changeFontStyle" v-model="toggle_multiple" color="primary" dense group multiple>
        <v-btn outlined :color="data.fontColor" @click="isShowSelectionColor = true" text small>
          <v-icon>mdi-format-color-text</v-icon>
        </v-btn>
        <v-btn :value="1" text small>
          <v-icon>mdi-format-bold</v-icon>
        </v-btn>

        <v-btn :value="2" text small>
          <v-icon>mdi-format-italic</v-icon>
        </v-btn>

        <v-btn :value="3" text small>
          <v-icon>mdi-format-underline</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-btn-toggle v-if="isAlign" v-model="data.align" color="primary" dense group mandatory>
        <v-btn :value="'left'" text small>
          <v-icon>mdi-format-align-left</v-icon>
        </v-btn>
        <v-btn :value="'center'" text small>
          <v-icon>mdi-format-align-center</v-icon>
        </v-btn>
        <v-btn :value="'right'" text small>
          <v-icon>mdi-format-align-right</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-checkbox class="mt-2 mx-2" v-model="data.caps" :label="`All Caps`"></v-checkbox>
    </v-col>
    <v-col cols="12" class="mb-3"
      ><h4>Allow the following characters</h4>
      <v-row>
        <v-col>
          <v-checkbox
            label="Characters"
            v-model="data.validations.allowed_characters"
            value="characters"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col>
          <v-checkbox
            label="Numbers"
            v-model="data.validations.allowed_characters"
            value="numbers"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col>
          <v-checkbox
            label="Special Characters"
            v-model="data.validations.allowed_characters"
            value="special_characters"
            hide-details
          ></v-checkbox>
        </v-col> </v-row
    ></v-col>
    <v-col cols="12" style="border-top: 1px solid silver;">
      <v-btn class="mt-2 mr-5" small color="error" outlined @click="$emit('deleteSelection')">
        Remove this object</v-btn
      >
    </v-col>
  </v-row>
</template>

<script>
import { uploadService } from '@/apis/upload.s';
import fileHelpers from '@/helpers/file';
import { personalizesApi } from '@/apis/personalizes';

import axios from 'axios';
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    isAlign: {
      type: Boolean,
      default: true,
    },
    fonts: {
      type: Array,
      default: () => [],
    },
    isTextColor: {
      type: Boolean,
      default: true,
    },
    windowTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      colorsText: '',
      isShowSelectionColor: false,
      colors: '#194d33',
      itemsFontsize: [],
      toggle_multiple: [],
      fileHelpers,
      init: true,
    };
  },

  watch: {
    toggle_multiple: {
      handler: function() {
        this.data.bold = this.toggle_multiple.includes(1);
        this.data.italic = this.toggle_multiple.includes(2);
        this.data.underline = this.toggle_multiple.includes(3);
      },
      deep: true,
    },
    data: {
      handler: function() {
        this.toggle_multiple = [];
        if (this.data.bold) this.toggle_multiple.push(1);
        if (this.data.italic) this.toggle_multiple.push(2);
        if (this.data.underline) this.toggle_multiple.push(3);

        this.data.validations.max_length = this.data.maxLength;
        this.data.validations.required = this.data.required;
        this.$emit('updateData', this.data, this.type);
      },
      deep: true,
    },
    windowTitle(newValue, oldValue) {
      console.log(newValue, oldValue);
    },
  },
  mounted() {
    this.init = true;
    for (let i = 8; i <= 500; i++) {
      this.itemsFontsize.push({ name: `${i}px`, id: `${i}px` });
    }
    this.colors = this.data.fontColor;
    if (this.data.bold) this.toggle_multiple.push(1);
    if (this.data.italic) this.toggle_multiple.push(2);
    if (this.data.underline) this.toggle_multiple.push(3);
    this.init = false;
  },
  methods: {
    async removeFont(item) {
      try {
        await personalizesApi.removeFont(item.id);
        this.$emit('loadFont');
      } catch (error) {}
    },
    changeFont(e) {
      if (e && typeof e === 'object') {
        let f = this.fonts.find(item => item.name === e.name);
        this.data.fontFamily = f.name;
        this.$emit('updateData', this.data, this.type);
      }
    },
    clickUploadFile() {
      this.resetImageUploader();
      this.$refs.fileUploader.click();
    },
    resetImageUploader() {
      this.$refs.fileUploader.value = '';
    },
    async uploadFont(e) {
      let file = e.target.files[0];
      if (file.name.toLowerCase().includes('.otf') || file.name.toLowerCase().includes('.ttf'))
        try {
          let urlData = await uploadService.get({ filename: `${file.name.replace(/\s/g, '-')}` });
          if (urlData) {
            let res = await axios.put(urlData.data.presignedUrl, file, {
              headers: {
                'Content-Type': `${file.type}`,
              },
            });
            let font = await personalizesApi.uploadFont({
              name: file.name.split('.')[0],
              fontUrl: this.fileHelpers.url(urlData.data.imagePath),
              // isPublic:true
            });
            if (font) {
              this.$emit('loadFont');
            }
          }
        } catch (error) {
          this.$store.commit('setMessages', {
            messages: 'Error  ',
            type: 'error',
          });
        }
      this.$refs.fileUploader.value = '';
    },
    addText() {
      this.windowTitle = 'Text Customize';
      this.$emit('addText');
    },
    addImage() {
      this.windowTitle = 'Image Customize';
      this.$emit('addImage');
    },
    refresh() {
      location.reload();
    },
    changeFontStyle() {},
    onClickOutside() {
      this.isShowSelectionColor = false;
    },
    updateValue() {
      this.data.fontColor = this.colors.hex;
    },
  },
};
</script>

<style lang="scss">
.tool-bar-style {
  .v-toolbar__content {
    padding: 0px;
  }
  .sketch-color {
    position: absolute;
    z-index: 1;
    // top: -300px;
  }
  display: flex;
  align-items: center;
  z-index: 1000000000000000000;
  position: relative;
}
</style>
